import React from 'react';
import Button from './ui/Button.jsx';

// React 18 requires class component for error boundaries
export default class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[ErrorBoundary]', error, info.componentStack);
  }

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    if (this.props.fallback) {
      return this.props.fallback;
    }

    return (
      <div className="min-h-screen flex items-center justify-center bg-surface px-6">
        <div className="max-w-lg w-full rounded-lg bg-surface-raised p-8 border border-white/10">
          <h1 className="text-h3 font-semibold text-ink-50 mb-2">Something broke.</h1>
          <p className="text-body text-ink-200 mb-6">An error stopped this page from loading.</p>
          <div className="rounded bg-surface p-4 mb-6 overflow-x-auto">
            <span className="text-mono-sm text-feedback-danger font-mono break-words">
              {this.state.error?.message ?? String(this.state.error ?? 'Unknown error')}
            </span>
          </div>
          <Button
            variant="ghost"
            as="button"
            onClick={() => window.location.reload()}
          >
            Reload page
          </Button>
        </div>
      </div>
    );
  }
}
